import type { FeatureShellPorts } from '@src/core/bootstrap/FeatureShellPorts.ts';
import type { PresentationShellPort } from '../../application/ports/PresentationShellPort.ts';

/** Lit web-components shell (only supported presentation mode). */
export async function createPresentationShell(): Promise<PresentationShellPort<FeatureShellPorts>> {
  const { LitPresentationShellAdapter } = await import('../adapters/LitPresentationShellAdapter.ts');
  return new LitPresentationShellAdapter();
}
